<template>
  <div class="footer">
    <img class="upImg" @click="scrollToTop" src="../assets/images/up.png" alt="" />
    <div class="top-footer">
      <ul class="listBox">
        <li v-for="(item, i) in navList" :key="item.id" @click="handleGo(item)">
          {{ item.name }}
        </li>
      </ul>
      <div class="codeBox">
        <img src="../assets/images/weixin.jpg" alt="" />
        <img src="../assets/images/weChat-1.png" alt="" />
        <img src="../assets/images/xiaohongshu.png" alt="" />
      </div>
      <p class="about">关注我们</p>
    </div>
    <div class="bottom-footer">
      <div class="textBox">
        <div class="ICP">
          <p class="address">©2024 湖南白白兔生物科技有限公司</p>
          <p class="record">湘ICP备2024088577号-2</p>
        </div>
        <div class="logo">
          <span>BAIBAITU</span>
        </div>
      </div>
      <div class="box">
        <div class="solid"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',

  data() {
    return {
      navList: [
        {
          name: '产品',
          path: '/product'
        },
        {
          name: '品牌故事',
          path: '/home'
        },

        {
          name: '品牌加盟',
          path: '/Business'
        },
        {
          name: '最新资讯',
          path: '/article'
        },
        {
          name: '联系我们',
          path: '/about'
        }
      ]
    }
  },

  methods: {
    handleGo(item) {
      this.$router.push({
        path: item.path
      })
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .footer {
    font-family: PingFangSC, PingFang SC;
    position: relative;
    // background: rgba(170, 212, 250, 0.1); /* 设置背景色的透明度 */
  }
  .upImg {
    width: 44px;
    position: absolute;
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
  }
  .listBox {
    display: flex;
    flex-wrap: wrap;
    margin: 0 34px;
    justify-content: space-between;
    li {
      font-weight: 500;
      font-size: 13px;
      margin-bottom: 6px;
      color: #000000;
      text-align: center;
      width: 144px;
      height: 35px;
      line-height: 35px;
      background-image: url(../assets/images/bubble.png);
      background-repeat: no-repeat;
      background-size: 144px auto; /* 宽度为200px，高度自适应 */
    }
  }
  .codeBox {
    margin: 0 47px;
    display: flex;
    justify-content: space-between;
    img {
      width: 82px;
    }
  }
  .about {
    font-weight: 500;
    font-size: 13px;
    color: #000000;
    line-height: 19px;
    margin: 12px 0 18px 0;
    text-align: center;
  }

  .bottom-footer {
    width: 100%;
    background-image: url(../assets/images/footer1.png);
    background-size: cover;
    .ICP {
      font-size: 10px;
      color: #ffffff;
      line-height: 14px;
    }
    .logo {
      font-family: HYk2gj;
      font-size: 14px;
      color: #ffffff;
      line-height: 14px;
      font-weight: 600;
    }
    .textBox {
      padding: 20px 20px 7px 43px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .box {
      padding-bottom: 9px;
      .solid {
        width: 134px;
        height: 5px;
        background: #ffffff;
        border-radius: 100px;
        margin: auto;
      }
    }
  }
}
</style>
